import { useIsMobile } from '@acceso/design-system';
import { useEffect, useRef, useState } from 'react';

import { useMediaManagerMenu } from '@/features/app/hooks/useMediaManagerMenu';
import { useUserMenu } from '@/features/users/hooks/use-user-menu';
import { useMenu } from '@/hooks/useMenu';
import { RESOURCE_TYPE } from '@/lib/auth';

const useAppLayoutState = () => {
  const [showSelector, setShowSelector] = useState(true);
  const [currentPos, setCurrentPos] = useState(0);

  const menu = useMenu({
    targetMenu: useMediaManagerMenu(),
    resourceType: RESOURCE_TYPE.PLATFORM,
  });
  const isMobile = useIsMobile();
  const containerRef = useRef<HTMLDivElement>(null);
  const userMenuState = useUserMenu();

  useEffect(() => {
    if (isMobile) {
      const handleScroll = (event: Event) => {
        const target = event.target as HTMLElement;

        setShowSelector(target.scrollTop === 0 || currentPos > target.scrollTop);
        setCurrentPos(target.scrollTop);
      };

      containerRef?.current?.addEventListener('scroll', handleScroll);

      return () => {
        containerRef?.current?.removeEventListener('scroll', handleScroll);
      };
    }
  }, [containerRef, currentPos, isMobile]);

  return {
    isMobile,
    showSelector,
    menu,
    containerRef,
    userMenuState,
  };
};

export { useAppLayoutState };
